import { render, staticRenderFns } from "./DeleteStudentPayment.vue?vue&type=template&id=7ac93f4b&scoped=true"
import script from "./DeleteStudentPayment.vue?vue&type=script&lang=js"
export * from "./DeleteStudentPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac93f4b",
  null
  
)

export default component.exports